module.exports = __webpack_public_path__ + "img/learn-3-dark.44157759.png";